/**
 * @flow
 * @relayHash 242c1fbf412fa12f5638b3beca564ac7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DividendDefForm_viewer$ref = any;
export type DividendDefFormQueryVariables = {|
  brokerActivityId?: ?string
|};
export type DividendDefFormQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: DividendDefForm_viewer$ref
  |}
|};
export type DividendDefFormQuery = {|
  variables: DividendDefFormQueryVariables,
  response: DividendDefFormQueryResponse,
|};
*/


/*
query DividendDefFormQuery(
  $brokerActivityId: ID
) {
  viewer {
    ...DividendDefForm_viewer_2gRrMZ
    id
  }
}

fragment DividendDefForm_viewer_2gRrMZ on Query {
  ibCashTransactions(id: $brokerActivityId) {
    edges {
      node {
        id
        group {
          id
          description
          dividenddef {
            description
            currency
            id
            createdAt
            updatedAt
            payDate
            exDate
            rateFranked
            frankingTaxRate
            dividendAmount
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "brokerActivityId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DividendDefFormQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DividendDefForm_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "brokerActivityId",
                "variableName": "brokerActivityId"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DividendDefFormQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "ibCashTransactions",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "brokerActivityId"
              }
            ],
            "concreteType": "IBCashTransactionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCashTransactionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "IBCashTransactionNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "group",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityGroupNode",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "dividenddef",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DividendDefNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "currency",
                                "args": null,
                                "storageKey": null
                              },
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "createdAt",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "updatedAt",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "payDate",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "exDate",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "rateFranked",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "frankingTaxRate",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "dividendAmount",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DividendDefFormQuery",
    "id": null,
    "text": "query DividendDefFormQuery(\n  $brokerActivityId: ID\n) {\n  viewer {\n    ...DividendDefForm_viewer_2gRrMZ\n    id\n  }\n}\n\nfragment DividendDefForm_viewer_2gRrMZ on Query {\n  ibCashTransactions(id: $brokerActivityId) {\n    edges {\n      node {\n        id\n        group {\n          id\n          description\n          dividenddef {\n            description\n            currency\n            id\n            createdAt\n            updatedAt\n            payDate\n            exDate\n            rateFranked\n            frankingTaxRate\n            dividendAmount\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba22a295aca253abf03bb6beac0622e5';
module.exports = node;
